<template>
  <!-- REGISTRATION MODAL -->
  <div
    class="modal fade"
    id="registrationModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="registrationModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <form id="registration_form" @submit.prevent="register()">
        <div class="modal-content">
          <div class="modal-header p-4">
            <h5 class="fw-bold mb-0" id="registrationModalLabel">
              Registration
            </h5>
            <a
              href="#"
              class="btn btn-default btn-icon btn-icon-sm rounded-circle"
              role="button"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="fas fa-times"></i>
            </a>
          </div>
          <div class="modal-body p-0">
            <div class="card-body border-bottom p-4">
              <div class="row g-3 g-md-4">
                <div class="col-12">
                  <input
                    class="form-control"
                    placeholder="Fullname"
                    v-model="full_name"
                    required
                  />
                </div>
                <div class="col-12">
                  <input
                    class="form-control"
                    placeholder="Email"
                    v-model="email"
                    type="email"
                    required
                  />
                </div>
                <div class="col-12">
                  <input
                    class="form-control"
                    placeholder="Password"
                    type="password"
                    v-model="password"
                    required
                  />
                </div>
                <div class="col-12">
                  <input
                    class="form-control"
                    placeholder="Confirm Password"
                    type="password"
                    v-model="confirm_password"
                    required
                  />
                </div>
                <div class="col-12">
                  <input
                    class="form-control"
                    type="number"
                    placeholder="Contact No."
                    v-model="contact_no"
                    required
                  />
                </div>
                <div class="col-12">
                  <p>
                    By clicking the "Register" button, you agree with the
                    <a href="">privacy policy</a> and
                    <a href="">terms & conditions</a> of rentease.
                  </p>
                </div>
                <div class="col-12">
                  <button type="submit" class="btn btn-primary btn-lg w-100">
                    Register
                  </button>
                  <!-- <p>
                  Already have an account?<a href="#" @click.prevent="hasAccount()">
                    CLICK HERE</a
                  >
                </p> -->
                  <!-- <p>
                  By clicking the "Register" button, you agree with the <a href="">privacy policy</a> and <a href="">terms & conditions</a> of rentease.
                </p> -->
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-12">
              <p class="text-center">
                Already have an account?<a
                  href="#"
                  @click.prevent="hasAccount()"
                >
                  LOGIN HERE</a
                >
              </p>
            </div>

            <!-- <button
            type="button"
            class="btn btn-transparent btn-sm"
            data-bs-dismiss="modal"
          >
            Clear all
          </button> -->
            <!-- <button type="submit" class="btn btn-primary btn-sm">Register</button> -->
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- END REGISTRATION MODAL -->
</template>
<script>
export default {
  name: "Registration",
  data: () => ({
    url: process.env.VUE_APP_API_URL,
    email: "",
    password: "",
    contact_no: "",
    full_name: "",
    confirm_password: "",
    is_auth_hidden: true,
    authenticationModalData: [],
  }),
  methods: {
    async register() {
      const formData = new FormData();
      formData.append("ContactNo", this.contact_no);
      formData.append("GuestName", this.full_name);
      formData.append("EmailAddress", this.email);
      formData.append("UserPassword", this.password);
      try {
        if (this.confirm_password != this.password) {
          alert("Password did not match");
        } else {
          const res = await axios.post(this.url + "/api/register", formData);
          if (res.data.success == true) {
            localStorage.setItem("userEmail", res.data.data.emailAddress);
            localStorage.setItem("userName", res.data.data.guestName);
            location.reload();
            $("#registrationModal").modal("hide");
          }
        }
      } catch (error) {
        alert("Email is already exist");
      }
    },
    hasAccount() {
      $("#registrationModal").modal("hide");
      $("#loginModal").modal("show");
      //this.$emit("showModal");
    },
  },
};
</script>
